import type { CarPark, Rect, TrackDef } from '../track';

/**
 * Desert City GP: tribute to the original's round 1, USA – Phoenix
 * (design.md A5.1, B5.1). The centre line is traced from the map the
 * original game draws on its LAP RECORDS screen (map units = C64 pixels of
 * that map). Street circuit: 90° corners, walls close to the track, and the
 * Phoenix car-park shortcut — here in the notch between M, N, O and P,
 * letting a brave driver skip the N–O jog.
 */

const centerline: [number, number][] = [
  [1.5, 1.5], //  0 A  start/finish straight (east)
  [32.5, 1.5], //  1 B
  [32.5, 9], //  2 C
  [28.5, 13], //  3 D
  [28.5, 17], //  4 E
  [34, 17], //  5 F
  [34, 34.5], //  6 G
  [27, 34.5], //  7 H
  [27, 60.5], //  8 I
  [11, 60.5], //  9 J
  [11, 56.5], // 10 K
  [5, 54], // 11 L
  [5, 35.5], // 12 M  ← car park entry
  [12.5, 32], // 13 N
  [12.5, 13.5], // 14 O
  [1.5, 13], // 15 P  ← car park exit
];

/** Car park rectangle in map units, and its islands of parked cars. */
function makeCarPark(): CarPark {
  const x = 2.5;
  const y = 14.6;
  const w = 7.6;
  const h = 19.9;
  const columns: [number, number][] = [
    [0.0, 0.15],
    [0.4, 0.56],
    [0.74, 0.88],
  ];
  const rows: [number, number][] = [
    [0.12, 0.47],
    [0.55, 0.88],
  ];
  const obstacles: Rect[] = [];
  for (const [c0, c1] of columns) {
    for (const [r0, r1] of rows) {
      obstacles.push({ x: x + c0 * w, y: y + r0 * h, w: (c1 - c0) * w, h: (r1 - r0) * h });
    }
  }
  return { x, y, w, h, obstacles };
}

export const DESERT_CITY: TrackDef = {
  id: 'desert-city',
  name: 'DESERT CITY GP',
  subtitle: 'Tribute to Phoenix, Arizona',
  country: 'USA',
  theme: 'desert',
  scale: 24,
  offset: [4, 4],
  centerline,
  roadWidth: 72,
  kerbWidth: 6,
  runoffWidth: 12,
  runoffSurface: 'dust',
  gates: [
    { seg: 0, t: 0.4 }, // start / finish
    { seg: 5, t: 0.5 },
    { seg: 7, t: 0.5 },
    { seg: 8, t: 0.5 },
    { seg: 11, t: 0.4 },
    { seg: 15, t: 0.5 },
  ],
  carparks: [makeCarPark()],
  // The car-park shortcut: straight on at M up the left aisle, out at P.
  shortcuts: [{ fromVertex: 11, toVertex: 15, via: [[4.8, 35.8], [4.6, 14.2]] }],
  raceLaps: 4,
  defaultRecord: 21.5,
};
